import React, { useEffect, useState } from "react";
import calender from "../../assets/calender.png";
import done from "../../assets/done.png";
import address from "../../assets/orders/address.png";
import desc from "../../assets/orders/desc.png";
import upload from "../../assets/orders/upload.png";
import { Button, Carousel, message, Modal, Radio, Space } from "antd";
import note from "../../assets/preview/note.png";
import { useDispatch, useSelector } from "react-redux";
import { updateOrderFunction } from "../../redux/orderUpdateSlice";
import { fetchOrderById } from "../../redux/ShowOrderIdSlice";
import { fetchOrdersByStatus } from "../../redux/orderUpdateSlice";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const ServiceRequestsPending = ({ idOrder, image, date, time , dateCreated , timeCreated}) => {
  const { t, i18n } = useTranslation();
  const { language } = i18n;
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalCancel, setIsModalCancel] = useState(false);
  const [isModalView, setIsModalView] = useState(false);
  const [currentOrder, setCurrentOrder] = useState(null);

  const { order, status, error } = useSelector((state) => state.order);

  const showModal = async () => {
    await dispatch(fetchOrderById(idOrder));
    setCurrentOrder(order);
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
    setCurrentOrder(null);
  };

  const showModalCancel = () => {
    setIsModalCancel(true);
  };
  const handleOkCancel = () => {
    setIsModalCancel(false);
  };
  const handleCancelCancel = () => {
    setIsModalCancel(false);
  };

  const showModalView = () => {
    setIsModalView(true);
  };
  const handleOkView = () => {
    setIsModalView(false);
  };
  const handleCancelView = () => {
    setIsModalView(false);
  };

  const { updateOrder, statusUpdate } = useSelector(
    (state) => state.updateOrder
  );

  useEffect(() => {
    if (statusUpdate === "idle") {
      dispatch(updateOrderFunction("cancelled", idOrder));
    }
  }, [dispatch, statusUpdate, idOrder]);

  const [value, setValue] = useState(1);
  const onChange = (e) => {
    console.log("radio checked", e.target.value);
    setValue(e.target.value);
  };

  useEffect(() => {
    dispatch(fetchOrdersByStatus("pending"));
    dispatch(fetchOrdersByStatus("finished"));
  }, [dispatch]);

  return (
    <div>
      <div className="  bg-white shadow-2xl rounded-2xl mt-4 p-4 ">
        <div className="">
          <div className="lg:flex items-center max-lg:mx-auto">
            <div className="bg-[#FCFBFA] p-3 rounded-2xl max-lg:w-full max-lg:mx-auto max-lg:mb-3">
              <img src={image} className="w-[80px] max-lg:mx-auto" />
            </div> 
            <p
              className={`${
                language == "en" ? "ml-3" : "mr-3"
              } text-[#737E91] font-semibold`}
            >
              {t("Order number")}
              <span className="text-[#283D63] font-semibold">#{idOrder}</span>
              <div className="flex items-center mt-3 ">
                <img
                  src={calender}
                  className={`w-[18px] ${language == "en" ? "mr-2" : "ml-2"}`}
                />
                <p className="text-[#283D63] font-medium">
                  {date} | {time}
                </p>
              </div>
            </p>
          </div>
        </div>
        <div className="flex justify-center my-5 ">
          <div>
            <button
              onClick={showModal}
              className="bg-[#FE9B71] text-white rounded-full px-8 max-lg:px-3 h-10 mx-3"
            >
              {t("Preview order")}
            </button>
            <Modal
              title={t("Order Preview")}
              className="orderModal"
              open={isModalOpen}
              onOk={handleOk}
              onCancel={handleCancel}
              footer={null}
            >
              <div className="mt-6">
                <img src={note} className="w-[30px] mx-auto" />
                <p className="text-[#737E91] text-lg mt-4 mx-auto text-center">
                  {t("Order is pending. An agent is being recruited")}
                </p>

                <img src={image} className="w-[120px] mx-auto my-5" />
                <div className="text-center">
                  <p className="text-[#737E91] font-semibold text-xl">
                    {t("Order number")}
                    <span className="text-[#283D63] font-semibold">
                      #{idOrder}
                    </span>
                  </p>
                  <p className="text-[#A6ADB9] mt-2">
                    {t("Order created on")} {dateCreated} <br /> {timeCreated}
                  </p>
                </div>

                <div className="px-5">
                  <div className="grid grid-cols-2 gap-4 max-xl:grid-cols-1 items-center">
                    <div className="flex items-center mt-3 ">
                      <img
                        src={calender}
                        className={`w-[28px] ${
                          language == "en" ? "mr-2" : "ml-2"
                        }`}
                      />
                      <p className="text-[#283D63] font-medium">
                        {date} | {time}
                      </p>
                    </div>
                    <div className="flex items-center mt-3 ">
                      <img
                        src={address}
                        className={`w-[28px] ${
                          language == "en" ? "mr-2" : "ml-2"
                        }`}
                      />
                      <p className="text-[#283D63] font-medium">
                        {order?.address}
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start mt-5 ">
                    <img
                      src={desc}
                      className={`w-[28px] ${
                        language == "en" ? "mr-2" : "ml-2"
                      }`}
                    />
                    <p className="text-[#283D63] font-medium">
                      {order?.description}
                    </p>
                  </div>

                  <div className="flex items-center mt-5 ">
                    <img
                      src={upload}
                      className={`w-[28px] ${
                        language == "en" ? "mr-2" : "ml-2"
                      }`}
                    />
                    {order?.uploaded_images?.length > 0 ? (
                      <>
                        <button
                          onClick={showModalView}
                          className="text-[#6682B6] underline font-medium"
                        >
                          {t("View Uploaded Images")}
                        </button>
                        <Modal
                          title={t("Uploaded Images")}
                          className="orderModal orderModalPricing w_small_modal"
                          open={isModalView}
                          onOk={handleOkView}
                          onCancel={handleCancelView}
                          footer={null}
                        >
                          <Carousel
                            arrows
                            infinite={false}
                            className="custome_carousel_images"
                          >
                            {order?.uploaded_images?.map((img, index) => (
                              <div key={index}>
                                <img
                                  src={`https://service.samoolah.com/${img}`}
                                  alt={`Uploaded image ${index + 1}`}
                                  className="w-[120px] mx-auto my-5"
                                />
                              </div>
                            ))}
                          </Carousel>
                        </Modal>
                      </>
                    ) : (
                      <p className="text-[#283D63] font-medium">
                        {t("No Uploaded Images")}
                      </p>
                    )}
                  </div>
                </div>

                <button
                  onClick={showModalCancel}
                  className="text-[#FE9B71] rounded-full text-lg border-2 border-[#FE9B71] px-10 py-2 mt-10 mb-5 flex mx-auto"
                >
                  {t("Cancel order")}
                </button>
                <Modal
                  title={t("Are you sure you want to cancel?")}
                  className="orderModal orderModalPricing w_small_modal"
                  open={isModalCancel}
                  onOk={handleOkCancel}
                  onCancel={handleCancelCancel}
                  footer={null}
                >
                  <form
                    className="mx-5 my-5"
                    onSubmit={(e) => {
                      e.preventDefault();
                      if (value) {
                        dispatch(
                          updateOrderFunction({
                            status: "cancelled",
                            order_id: idOrder,
                            cancel_reason: value,
                          })
                        );
                        setIsModalCancel(false);
                      } else {
                        console.error("Please select a cancellation reason.");
                      }
                    }}
                  >
                    <div>
                      <Radio.Group
                        onChange={(e) => setValue(e.target.value)}
                        value={value}
                        className="custome_radio custome_radio_color"
                      >
                        <Space direction="vertical">
                          <Radio value="I was trying the app">
                            {t("I was trying the app")}
                          </Radio>
                          <Radio value="I will try ordering this service later">
                            {t("I will try ordering this service later")}
                          </Radio>
                          <Radio value="Appointed technician is not replying">
                            {t("Appointed technician is not replying")}
                          </Radio>
                          <Radio value="No reason">{t("No reason")}</Radio>
                          <Radio value="Other">{t("Other")}</Radio>
                        </Space>
                      </Radio.Group>
                    </div>

                    <button
                      type="submit"
                      className="bg-[#FE9B71] text-white rounded-full py-2 px-10 flex mx-auto font-medium text-lg mt-5"
                    >
                      {t("Cancel order")}
                    </button>
                  </form>
                </Modal>
              </div>
            </Modal>
          </div>

          <div>
            <button
              onClick={showModalCancel}
              className="text-[#FE9B71] rounded-full h-10 border-2 border-[#FE9B71] px-8 max-lg:px-3"
            >
              {t("Cancel order")}
            </button>

            <Modal
              title={t("Are you sure you want to cancel?")}
              className="orderModal orderModalPricing w_small_modal"
              open={isModalCancel}
              onOk={handleOkCancel}
              onCancel={handleCancelCancel}
              footer={null}
            >
              <form
                className="mx-5 my-5"
                // onSubmit={(e) => {
                //   e.preventDefault();
                //   if (value) {
                //     dispatch(
                //       updateOrderFunction({
                //         status: "cancelled",
                //         order_id: idOrder,
                //         cancel_reason: value,
                //       })
                //     );
                //     setIsModalCancel(false);
                //   } else {
                //     console.error("Please select a cancellation reason.");
                //   }
                // }}
                onSubmit={async (e) => {
                  e.preventDefault();

                  if (value) {
                    try {
                      const canceledOrder = await dispatch(
                        updateOrderFunction({
                          status: "cancelled",
                          order_id: idOrder,
                          cancel_reason: value,
                        })
                      )
                        .unwrap()
                        .then(() => {
                          window.location.reload();
                          setIsModalCancel(false);
                          message.success("The order cancelled");
                        });
                    } catch (error) {
                      console.error("Error canceling order:", error);
                    }
                  } else {
                    console.error("Please select a cancellation reason.");
                  }
                }}
              >
                <div>
                  <Radio.Group
                    onChange={(e) => setValue(e.target.value)}
                    value={value}
                    className="custome_radio custome_radio_color"
                  >
                    <Space direction="vertical">
                      <Radio value="I was trying the app">
                        {t("I was trying the app")}
                      </Radio>
                      <Radio value="I will try ordering this service later">
                        {t("I will try ordering this service later")}
                      </Radio>
                      <Radio value="Appointed technician is not replying">
                        {t("Appointed technician is not replying")}
                      </Radio>
                      <Radio value="No reason">{t("No reason")}</Radio>
                      <Radio value="Other">{t("Other")}</Radio>
                    </Space>
                  </Radio.Group>
                </div>

                <button
                  type="submit"
                  className="bg-[#FE9B71] text-white rounded-full py-2 px-10 flex mx-auto font-medium text-lg mt-5"
                >
                  {t("Cancel order")}
                </button>
              </form>
            </Modal>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceRequestsPending;
